"use client";
import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { Popover } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { Postdata } from "../../../helpers/api.service";
import HttpService from "../../../helpers/httpServices";
import { useDispatch, useSelector } from "react-redux";
import { message } from "../../../redux/actions/toastActions";
import Select from "react-select";
import { isPermission, isRole, isRoleType } from "../../../redux/selectors/authSelector";
import { useCountryNavigate } from "../../common/UseCountryNavigate";

const DayPractice = ({ currentDate, setCurrentDate }) => {
  const [events, setEvents] = useState([]);
  const [selectedEvent, setSelectedEvent] = useState(null);

  const [selectedDate, setSelectedDate] = useState(
    dayjs().format("YYYY-MM-DD")
  );

  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    id: null,
    title: "",
    date: dayjs().format("YYYY-MM-DD"),
    start_time: "",
    end_time: "",
    place: "",
    members: [],
    board_members: [],
    notes: "",
    color: "#60a5fa",
  });
  const [editingIndex, setEditingIndex] = useState(null);
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [member, setMember] = useState([]);
  const [boardMember, setBoardMember] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const dispatch = useDispatch();
  const permissions = useSelector(isPermission);
  const role = useSelector(isRole);

  const role_type = useSelector(isRoleType);
  console.log("permissions", permissions);
  const addPermission =
    role == "admin" ||
    role == "subadmin" ||
    role == "schooladmin" ||
    (permissions && (permissions?.includes("edit_Education") || permissions?.includes("edit_School"))) ||
    false;
  const deletePermission =
    role == "admin" ||
    role == "subadmin" ||
    role == "schooladmin" ||
    (permissions && (permissions?.includes("delete_Education") || permissions?.includes("delete_School"))) ||
    false;
  const schoolId = localStorage.getItem("activeSchoolId");
  const hours = Array.from({ length: 24 }, (_, i) => i);
  const mode = localStorage.getItem("mode");
  const navigate = useCountryNavigate();
  const format12Hour = (hour) => {
    const suffix = hour >= 12 ? "PM" : "AM";
    const displayHour = hour % 12 === 0 ? 12 : hour % 12;
    return `${displayHour}:00 ${suffix}`;
  };

  // const calculatePosition = (start, end) => {
  //   const [startH, startM] = start.split(':').map(Number);
  //   const [endH, endM] = end.split(':').map(Number);
  //   const startMinutes = startH * 60 + startM;
  //   const endMinutes = endH * 60 + endM;
  //   const top = (startMinutes / 1440) * 100;
  //   const height = ((endMinutes - startMinutes) / 1440) * 100;
  //   return { top, height };
  // };

  const calculatePosition = (start, end) => {
    const [startH, startM] = start.split(":").map(Number);
    const [endH, endM] = end.split(":").map(Number);

    // Convert start and end times to minutes
    const startMinutes = startH * 60 + startM;
    const endMinutes = endH * 60 + endM;

    // Adjust for starting from 7 AM (420 minutes from midnight)
    const adjustedStartMinutes = startMinutes - 420; // 7 AM is 420 minutes from midnight
    const adjustedEndMinutes = endMinutes - 420;

    // Calculate the top position (relative to 7 AM) and event height
    const top = (adjustedStartMinutes / (1440 - 420)) * 100; // 1440 - 420 gives the minutes from 7 AM to midnight
    const height =
      ((adjustedEndMinutes - adjustedStartMinutes) / (1440 - 420)) * 100;

    return { top, height };
  };

  const handleTimeSlotClick = (hour) => {
    const start = `${String(hour).padStart(2, "0")}:00`;
    const end = `${String(hour + 1).padStart(2, "0")}:00`;
    setFormData({
      id: null,
      title: "",
      date: selectedDate,
      start_time: start,
      end_time: end,
      place: "",
      members: [],
      board_members: [],
      notes: "",
      color: "#60a5fa",
    });
    setEditingIndex(null);
    setModalOpen(true);
  };

  const handleEventClick = (event, index) => {
    console.log("event >>>>>>>>>", event);
    setFormData({ ...event, id: event._id });
    setEditingIndex(index);
    setModalOpen(true);
  };

  const handleSaveEvent = () => {
    // static

    // if (editingIndex !== null) {
    //   const updatedEvents = [...events];
    //   updatedEvents[editingIndex] = formData;
    //   setEvents(updatedEvents);
    // } else {
    //   setEvents([...events, { ...formData, id: Date.now() }]);
    // }
    if (isLoading) return;
    if (
      dayjs(`${formData.date}T${formData.end_time}`).isBefore(
        dayjs(`${formData.date}T${formData.start_time}`)
      )
    ) {
      dispatch(message("End time should be greater than Start time"));
      return; // stop submitting
    }

    let payload = {
      title: formData.title,
      place: formData.place,
      notes: formData.notes,
      date: formData.date,
      start_time: formData.start_time,
      end_time: formData.end_time,
      members: Array.isArray(formData.members) ? formData.members : [],
      board_members: Array.isArray(formData.board_members)
        ? formData.board_members
        : [],
      color: formData.color,
      school_id: schoolId,
    };
    if (formData.id) {
      payload.id = formData.id;
    }
    setIsLoading(true);
    Postdata(HttpService.calendar_event_add, payload).then((response) => {
      if (response.status === 200) {
        console.log(response.data);
        // setEvents(response.data)
        console.log();
        setRefresh(!refresh);
        setModalOpen(false);
        setEditingIndex(null);
        if (role === "admin" || role === "subadmin" || role_type === "schoolsubadmin" || role_type === "subadmin") {
          if (mode === "view") {
            navigate(`admin-school/view/${schoolId}`, {
              state: { mainTab: "Education" },
            });
          } else {
            navigate("navigation-dashboard", {
              state: { mainTab: "Education" },
            });
          }
        } else {
          navigate("education");
        }
      }
      // else {
      //   dispatch(message(response.message));
      // }
    })
      .finally(() => {
        // ✅ ensure loading resets
        setIsLoading(false);
      });
  };

  const isOverlap = (a, b) => {
    const [aStartH, aStartM] = a.start_time.split(":").map(Number);
    const [aEndH, aEndM] = a.end_time.split(":").map(Number);
    const [bStartH, bStartM] = b.start_time.split(":").map(Number);
    const [bEndH, bEndM] = b.end_time.split(":").map(Number);
    const aStart = aStartH * 60 + aStartM;
    const aEnd = aEndH * 60 + aEndM;
    const bStart = bStartH * 60 + bStartM;
    const bEnd = bEndH * 60 + bEndM;
    return aStart < bEnd && bStart < aEnd;
  };

  const groupOverlappingEvents = (events) => {
    const sorted = [...events].sort((a, b) => {
      const [aH, aM] = a.start_time.split(":").map(Number);
      const [bH, bM] = b.start_time.split(":").map(Number);
      return aH * 60 + aM - (bH * 60 + bM);
    });
    const groups = [];
    sorted.forEach((event) => {
      let placed = false;
      for (let group of groups) {
        if (group.some((e) => isOverlap(e, event))) {
          group.push(event);
          placed = true;
          break;
        }
      }
      if (!placed) {
        groups.push([event]);
      }
    });
    return groups;
  };

  const handleBoardMemberChange = (selected) => {
    const selectedNames = selected ? selected.map((item) => item.value) : [];
    setFormData({ ...formData, board_members: selectedNames });
  };

  const handleMemberChange = (selected) => {
    const selectedNames = selected ? selected.map((item) => item.value) : [];
    setFormData({ ...formData, members: selectedNames });
  };

  const fetchBoardMember = () => {
    setIsLoading(true);
    Postdata(HttpService.board_management_list, { school_id: schoolId }).then(
      (response) => {
        if (response.status === 200) {
          setBoardMember(response.data.boards);
          console.log("response.data)>>>>>>>>>>>", response.data.managers);
          setIsLoading(false);
        } else {
          setIsLoading(false);
          dispatch(message(response.message));
        }
      }
    );
  };
  const fetchMembers = () => {
    setIsLoading(true);
    Postdata(HttpService.school_management_list, { school_id: schoolId }).then(
      (response) => {
        if (response.status === 200) {
          setMember(response.data.managers);
          console.log("response.data)>>>>>>>>>>>", response.data.managers);
          setIsLoading(false);
        } else {
          setIsLoading(false);
          dispatch(message(response.message));
        }
      }
    );
  };
  const fetchEvents = () => {
    setIsLoading(true);
    Postdata(HttpService.calendar_event_list, { school_id: schoolId }).then(
      (response) => {
        if (response.status === 200) {
          setEvents(response.data);
          setIsLoading(false);
        } else {
          setIsLoading(false);
          dispatch(message(response.message));
        }
      }
    );
  };

  const handleDelete = (id) => {
    setIsLoading(true);
    Postdata(HttpService.calendar_event_delete, {
      id,
      school_id: schoolId,
    }).then((response) => {
      setRefresh(!refresh);
      dispatch(message(response.message));
    });
  };
  useEffect(() => {
    setSelectedDate(currentDate.format("YYYY-MM-DD"));
  }, [currentDate]);

  useEffect(() => {
    fetchEvents();
  }, [refresh]);

  useEffect(() => {
    fetchMembers();
    fetchBoardMember();
    fetchEvents();
  }, []);

  const todaysEvents = events.filter((e) => e.date === selectedDate);
  const eventGroups = groupOverlappingEvents(todaysEvents);

  return (
    <div className="flex flex-col h-[calc(100vh-80px)] bg-gray-50">
      {/* Header with Date Picker */}
      {/* <div className="p-4 flex items-center gap-4 bg-white border-b">
        <Popover className="relative">
          {({ open }) => (
            <>
              <Popover.Button className="px-3 py-2 border rounded flex items-center gap-2 text-sm bg-white shadow-sm">
                {dayjs(selectedDate).format('ddd, MMM D, YYYY')}
                <ChevronDownIcon className="w-4 h-4" />
              </Popover.Button>
              <Popover.Panel className="absolute z-10 mt-2 bg-white p-2 border rounded shadow">
                <input
                  type="date"
                  value={selectedDate}
                  onChange={(e) => {
                    setSelectedDate(e.target.value);
                    setCurrentDate(dayjs(e.target.value));
                  }}
                  className="border p-2 rounded text-sm"
                />
              </Popover.Panel>
            </>
          )}
        </Popover>
        <span className="text-sm text-gray-600">Select and view today's events</span>
      </div> */}

      <div className="flex flex-1 overflow-y-scroll">
        <div className="w-20 flex flex-col">
          {/* Adjust hours to start from 7 AM */}
          {Array.from({ length: 24 }).map((_, i) => {
            const hour = i + 7; // Start from 7 AM
            return (
              <div
                key={hour}
                className="h-28 border-t border-gray-200 text-xs text-gray-600 pl-2 pt-1"
              >
                {format12Hour(hour)}{" "}
                {/* Use the updated format12Hour function */}
              </div>
            );
          })}
        </div>

        {/* Timeline and Events */}
        <div className="relative flex-1 border-l border-gray-300 bg-white">
          {/* Adjust timeline to start from 7 AM */}
          {Array.from({ length: 24 }).map((_, i) => {
            const hour = i + 7; // Start from 7 AM
            return (
              <div
                key={hour}
                className="border-t border-gray-200 h-6 relative cursor-pointer"
                onClick={() => handleTimeSlotClick(hour)}
              />
            );
          })}

          {/* Display events with adjusted positions */}
          {eventGroups.map((group) => {
            const groupSize = group.length;
            return group.map((event, idx) => {
              const { top, height } = calculatePosition(
                event.start_time,
                event.end_time,
                7 // Adjust event start time to begin from 7 AM
              );
              return (
                <div
                  key={event.id}
                  className="absolute text-white rounded p-1 text-xs cursor-pointer shadow-md transition-transform overflow-hidden"
                  style={{
                    top: `${top}%`, // Adjusted based on the start time from 7 AM
                    height: `${height}%`, // Adjusted height based on event duration
                    left: `${(idx * 100) / groupSize}%`,
                    width: `${100 / groupSize}%`,
                    backgroundColor: event.color || "#60a5fa",
                  }}
                >
                  <div className="flex gap-5 items-center">
                    <div onClick={() => handleEventClick(event, idx)}>
                      {event.title}
                    </div>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedEvent(event);
                      }}
                      className="ml-1 text-white hover:text-gray-200"
                      title="View Details"
                    >
                      👁️
                    </button>
                  </div>
                  <div className="text-[10px]">
                    {event.start_time} - {event.end_time}
                  </div>
                </div>
              );
            });
          })}
        </div>
      </div>

      {/* Detail tooltip */}

      {selectedEvent && (
        <div className="fixed inset-0 z-50 flex items-center justify-center pointer-events-none">
          <div className="bg-white rounded-xl shadow-lg p-3 w-[320px] relative pointer-events-auto">
            <button
              onClick={() => setSelectedEvent(null)}
              className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 text-lg"
            >
              ✕
            </button>
            <h2 className="text-lg font-bold text-gray-900 mb-1">
              {selectedEvent.title}
            </h2>
            <p className="text-sm text-gray-500 mb-3">
              {dayjs(selectedEvent.date).format("dddd, MMM D")}
              <br />
              {dayjs(`2020-01-01T${selectedEvent.start_time}`).format(
                "h:mm A"
              )}{" "}
              – {dayjs(`2020-01-01T${selectedEvent.end_time}`).format("h:mm A")}
            </p>
            {selectedEvent.place && (
              <p className="mb-1">
                <span className="font-semibold text-gray-700">Place:</span>{" "}
                {selectedEvent.place}
              </p>
            )}
            {selectedEvent.members.length > 0 && (
              <p className="mb-1">
                <span className="font-semibold text-gray-700">Members:</span>{" "}
                {selectedEvent.members
                  .map((id) => member.find((m) => m._id === id)?.name || id)
                  .join(", ")}
              </p>
            )}
            {selectedEvent.board_members.length > 0 && (
              <p className="mb-3">
                <span className="font-semibold text-gray-700">
                  Board Members:
                </span>{" "}
                {selectedEvent.board_members
                  .map(
                    (id) => boardMember.find((m) => m._id === id)?.name || id
                  )
                  .join(", ")}
              </p>
            )}
            <div className="flex justify-end space-x-4">
              {addPermission && (
                <button
                  onClick={() => {
                    setFormData({ ...selectedEvent, id: selectedEvent._id });
                    setEditingIndex(
                      events.findIndex((e) => e.id === selectedEvent.id)
                    );
                    setModalOpen(true);
                    setSelectedEvent(null);
                  }}
                  className="text-indigo-600 text-sm hover:underline"
                >
                  Edit
                </button>
              )}
              {deletePermission && (
                <button
                  onClick={() => {
                    handleDelete(selectedEvent._id);
                    setSelectedEvent(null);
                  }}
                  className="text-red-500 text-sm hover:underline"
                >
                  Delete
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modal */}
      {modalOpen && addPermission && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-25">
          <div className="bg-white rounded-2xl shadow-xl p-6 w-full max-w-md space-y-4">
            <div className="flex justify-between items-center">
              <input
                type="text"
                placeholder="Event Title"
                className="text-lg font-semibold w-full outline-none"
                value={formData.title}
                onChange={(e) =>
                  setFormData({ ...formData, title: e.target.value })
                }
              />
              <div className="relative ml-3">
                <button
                  className="w-10 h-6 flex items-center justify-center rounded-full border bg-white shadow"
                  onClick={() => setShowColorPicker(!showColorPicker)}
                >
                  <span
                    className="w-3 h-3 rounded-full"
                    style={{ backgroundColor: formData.color }}
                  />
                </button>
                {showColorPicker && (
                  <div className="absolute right-0 mt-2 bg-white p-2 rounded shadow grid gap-2 z-10">
                    {[
                      "#f87171",
                      "#facc15",
                      "#4ade80",
                      "#60a5fa",
                      "#a78bfa",
                      "#f472b6",
                    ].map((color) => (
                      <button
                        key={color}
                        onClick={() => {
                          setFormData({ ...formData, color });
                          setShowColorPicker(false);
                        }}
                        className="w-5 h-5 rounded-full"
                        style={{ backgroundColor: color }}
                      />
                    ))}
                  </div>
                )}
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <input
                type="date"
                className="w-full border rounded px-3 py-2 outline-none"
                value={formData.date}
                onChange={(e) =>
                  setFormData({ ...formData, date: e.target.value })
                }
              />
              <input
                type="time"
                className="w-full border rounded px-3 py-2 outline-none"
                value={formData.start_time}
                onChange={(e) =>
                  setFormData({ ...formData, start_time: e.target.value })
                }
              />
              <input
                type="time"
                className="w-full border rounded px-3 py-2 outline-none"
                value={formData.end_time}
                onChange={(e) =>
                  setFormData({ ...formData, end_time: e.target.value })
                }
              />
            </div>
            <input
              type="text"
              placeholder="Place"
              className="w-full border rounded px-3 py-2 outline-none"
              value={formData.place}
              onChange={(e) =>
                setFormData({ ...formData, place: e.target.value })
              }
            />
            {/* <select
              className="w-full border rounded px-3 py-2 outline-none"
              value={formData.members}
              onChange={(e) => setFormData({ ...formData, members: e.target.value })}
            >
              <option value="">Select Member</option>
              {member.map((m) => (
                <option key={m.id} value={m.name}>{m.name}</option>
              ))}
            </select> */}

            <Select
              isMulti
              name="members"
              placeholder="School Members"
              options={member.map((m) => ({ value: m._id, label: m.name }))}
              value={
                formData.members &&
                formData.members.map((id) => ({
                  value: id,
                  label: member.find((m) => m._id === id).name,
                }))
              }
              onChange={handleMemberChange}
            />
            <Select
              isMulti
              name="board members"
              placeholder="Board Members"
              options={boardMember.map((m) => ({
                value: m._id,
                label: m.name,
              }))}
              value={
                formData.board_members &&
                formData.board_members.map((id) => ({
                  value: id,
                  label: boardMember.find((m) => m._id === id).name,
                }))
              }
              onChange={handleBoardMemberChange}
            />
            <textarea
              placeholder="Notes"
              className="w-full border rounded px-3 py-2 outline-none"
              rows={2}
              value={formData.notes}
              onChange={(e) =>
                setFormData({ ...formData, notes: e.target.value })
              }
            />
            <div className="flex justify-end space-x-2 pt-2">
              <button
                onClick={() => setModalOpen(false)}
                className="px-4 py-2 rounded bg-gray-100 hover:bg-gray-200"
              >
                Cancel
              </button>
              <button
                onClick={handleSaveEvent}
                disabled={isLoading}
                className={`px-4 py-2 rounded text-white transition ${isLoading
                  ? "bg-indigo-400 cursor-not-allowed"
                  : "bg-indigo-600 hover:bg-indigo-700"
                  }`}
              >
                {isLoading
                  ? "Saving..."
                  : editingIndex !== null
                    ? "Update"
                    : "Save"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DayPractice;
